/**
 * /bms不在使用环境判断。
 * 使用proxy的pathRewrite修改'/'代理
 */
export default {
  // 巡检标准
  standard: {
    getDeviceType: '/bms/device/queryDeviceTypeCount.json',   //设备类型
    getInspectionListNoPage: '/biz/tbl/pal/patrol/standard/list', // 获取巡检标准列表
    getInspectionList: '/bms/tbl/pal/patrol/standard/page', //获取巡检标准列表分页
    delStandard: '/bms/tbl/pal/patrol/standard/', // 删除巡检标准
    getStandardInfo: '/bms/tbl/pal/patrol/standard/', // 获取巡检标准信息
    getStandardItemList: '/bms/tbl/pal/patrol/standard/item/list', // 获取巡检标准巡检项列表
    addStandard: '/bms/tbl/pal/patrol/standard/addPalPatrolStandard.json', // 新增巡检标准
    editStandard: '/bms/tbl/pal/patrol/standard/editPalPatrolStandard.json', // 修改巡检标准
    saveStandardItemList: '/bms/tbl/pal/patrol/standard/item/addPalPatrolStandardItemList.json' // 批量保存巡检项
  },
  plan: {
    getPlanList: '/bms/tbl/pal/patrol/plan/page', // 获取计划列表
    startPlan: '/bms/tbl/pal/patrol/plan/enable.json', // 启用
    stopPlan: '/bms/tbl/pal/patrol/plan/disable.json', // 禁用
    delPlan: '/bms/tbl/pal/patrol/plan/',//删除
    getPlanDetail: '/bms/tbl/pal/patrol/plan/', //获取巡更计划详情
    addPlan: '/bms/tbl/pal/patrol/plan/addPalPatrolPlan.json', // 新增计划
    editPlan: '/bms/tbl/pal/patrol/plan/editPalPatrolPlan.json', // 修改计划
    savePlanItemList: '/bms/tbl/pal/patrol/plan/detail/addPalPatrolPlanDetailList.json', // 批量保存巡检项
    // getDeviceList: '/cms/authgroup/queryDeviceList.json', // 查询所有设备
    getDeviceList: '/bms/device/getDeviceListByPage.json', // 查询所有设备
    savePeopleList: '/bms/tbl/pal/patrol/plan/user/addPalPatrolPlanUserList.json', // 批量保存计划人员
    getUsersList: '/vas/personnel/queryPersonList.json', //查询所有人员
    getSysUsersList:'/cms/account/queryResultsByPag.json' //查询系统所有人员
  },
  task: {
    getTaskList: '/bms/tbl/pal/patrol/task/page', // 获取巡检任务列表
    deleteTask: '/bms/tbl/pal/patrol/task/remove/', // 删除任务
    deleteTasks: '/bms/tbl/pal/patrol/task/removeByIds/', // 删除多个任务
    getTaskDetail: '/bms/tbl/pal/patrol/task/', // 获取巡检任务详情
    queryDeviceItemList: '/bms/tbl/pal/patrol/task/item/list' // 获取设备巡检项明细
  }
}
